// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tree-label{display:flex;flex-direction:column}.tree-label-name{font-size:14px}.tree-label-value{font-size:12px;opacity:.8}.highlight-node{background:#6adbc3!important;border-radius:4px;padding:4px;transition:background .6s ease}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
